import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { calculatePercentage } from "../../SysGuard/sysGuardConstants";
import { isNull } from "lodash";

const TopPolicyRadial = ({ data }) => {
  const totalAlerts = data?.totalNoOfAlerts || 0;
  // Extract top3PolicyViolations from behaviorData
  const top3PolicyViolations = data?.top3PolicyViolations || [];
  const renderProgressColor = (value) => {
    if (value === 0) {
      return "#8dc63f";
    } else if (value <= 50) {
      return "#e9b047";
    } else {
      return "#f43860";
    }
  };

  return (
    <div className="top-policy-radial-container">
      {!isNull(totalAlerts) && totalAlerts === 0 && (
        <div className="no-data-message">No alerts in the selected time range</div>
      )}
      {top3PolicyViolations.slice(0, 3).map((policy, index) => {
        const matchedPolicy = data.countByPolicy?.find(
          (item) => item.policyName === policy
        );
        const policyAlertCount = matchedPolicy?.totalCount || 0;
        const percentage = calculatePercentage(
          policyAlertCount,
          totalAlerts
        );
        
        return (
          <div className="sys-guard-radial-progress-bar-container">
            <div key={index} className="top-policy sys-guard-text-container">
              <div className="sys-guard-radial-progress">
                <CircularProgressbarWithChildren
                  value={percentage}
                  styles={buildStyles({
                    pathColor: renderProgressColor(percentage),
                    strokeLinecap: "butt",
                    trailColor: "#e8e8e8ff",
                  })}
                  strokeWidth={10}
                >
                  <div className="circular-progress-bar-text">
                    <div className="text-sm">
                      {`${policyAlertCount}/${totalAlerts}`}
                    </div>
                    <div className="text-l">{`${percentage}%`}</div>
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="sys-guard-radial-text">{policy}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopPolicyRadial;
